// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"53f75cbd","663":"5a3f9bb2","690":"168bf92b","845":"a2d1dfd6","854":"70a83e30","975":"55acc2a3"}[chunkId] + ".chunk.js";
};